import { apiConfig } from "@/helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const roomService = {
    getAll,
    getAllRooms,
    create,
    get,
    update,
    deleteRoom
};

function getAll(data)
{
    return axios.get('/api/services/app/Room/GetAll', {
        params: {            
            Keyword: data.query,
            SkipCount: (data.page-1) * data.limit,
            MaxResultCount: data.limit,
            Sorting: data.sorting            
        },
        baseURL: apiConfig.apiUrl,
        headers: authHeader()        
    })
}
function getAllRooms()
{
    return axios.get('/api/services/app/Room/GetRooms', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()        
    })    
}
function create(data)
{
    return axios.post('/api/services/app/Room/Create',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })
}
function get(id)
{
    return axios.get('/api/services/app/Room/Get', {      
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            Id: id
        }
    })     
}
function update(data)
{
    return axios.put('/api/services/app/Room/Update',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })    
}
function deleteRoom(id)
{
    return axios.delete('/api/services/app/Room/Delete', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            Id: id
        }           
    })    
}